__turbopack_context__.v({
  "bannerWrapper": "sGo0_q_bannerWrapper",
  "desktopContent": "sGo0_q_desktopContent",
  "tabletContent": "sGo0_q_tabletContent",
});
